import { render, staticRenderFns } from "./BrandColorsModal.vue?vue&type=template&id=183c5c36&scoped=true"
import script from "./BrandColorsModal.vue?vue&type=script&lang=js"
export * from "./BrandColorsModal.vue?vue&type=script&lang=js"
import style0 from "./BrandColorsModal.vue?vue&type=style&index=0&id=183c5c36&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c5c36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183c5c36')) {
      api.createRecord('183c5c36', component.options)
    } else {
      api.reload('183c5c36', component.options)
    }
    module.hot.accept("./BrandColorsModal.vue?vue&type=template&id=183c5c36&scoped=true", function () {
      api.rerender('183c5c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/BrandColorsModal.vue"
export default component.exports